import { Link } from "#src/components/Router.tsx";
import tw from "#src/utils/tw.ts";
import { ClassNameValue } from "cn";
import { ReactNode } from "react";

interface Props {
  className?: string;
  onClick?: (e) => void;
  align?: string;
  to?: any;
  href?: string;
  target?: string;
  isPreview?: boolean;
  disabled?: boolean;
  children: ReactNode;
  style?: React.CSSProperties;
}

export default function LinkButton(props: Props) {
  const classNames: ClassNameValue = tw(
    "text-organization bg-none border-0 cursor-pointer outline-hidden transition-all hover:text-organization",
    "[&_.fa]:relative [&_.fa]:top-px",
    props.align === "right" && "float-right",
    props.disabled && "opacity-50 cursor-not-allowed",
    props.className
  );

  if (props.to) {
    return (
      <Link
        to={props.to}
        className={classNames}
        style={props.style}
        onClick={props.onClick}
      >
        {props.children}
      </Link>
    );
  }

  if (props.href) {
    return (
      <a
        href={props.href}
        className={classNames}
        target={props.target}
        style={props.style}
      >
        {props.children}
      </a>
    );
  }

  return (
    <button
      className={classNames}
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
      style={props.style}
    >
      {props.children}
    </button>
  );
}
